export default __webpack_public_path__ + "static/media/dots.3b6571b6.svg";